<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.25004 16.0417H3.20837M5.95837 11H1.83337M8.25004 5.95833H3.66671M15.5834 2.75L9.53664 11.2154C9.26901 11.5901 9.13519 11.7775 9.14098 11.9337C9.14603 12.0696 9.21124 12.1964 9.31897 12.2795C9.4427 12.375 9.67293 12.375 10.1334 12.375H14.6667L13.75 19.25L19.7968 10.7846C20.0644 10.4099 20.1982 10.2225 20.1924 10.0663C20.1874 9.93036 20.1222 9.80365 20.0145 9.7205C19.8907 9.625 19.6605 9.625 19.2 9.625H14.6667L15.5834 2.75Z"
    stroke="var(--stroke-color)"
    stroke-width="1.6"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
